const bgColorMapper: { [key: string]: string } = {
  white: '#ffffff',
  grey: '#6B7280',
  red: '#EF4444',
  orange: '#F97316',
  yellow: '#F59E0B',
  green: '#10B981',
  teal: '#14B8A6',
  cyan: '#06B6D4',
  'light blue': '#0EA5E9',
  blue: '#3B82F6',
  indigo: '#6366F1',
  'purple (violet)': '#8B5CF6',
  pink: '#EC4899',
  rose: '#F43F5E',
};

const bubbleBorderRadius = (variant: 'bot' | 'user') =>
  variant === 'bot'
    ? 'tw-rounded-tl-2xl tw-rounded-tr-2xl tw-rounded-br-2xl tw-rounded-bl'
    : 'tw-rounded-tl-2xl tw-rounded-tr-2xl tw-rounded-bl-2xl tw-rounded-br';

const textColor = (variant: 'bot' | 'user', theme: string) => (variant === 'bot' ? 'tw-text-gray-800' : 'tw-text-white');

const themeBorderColor = (theme: string) => (theme === 'light' ? 'tw-border-gray-300' : 'tw-border-gray-700');

const themeDisabledButtons = (theme: string) => (theme === 'light' ? 'disabled:tw-text-gray-300 ' : 'disabled:tw-text-gray-700');

const themeBackground = (theme: string) => (theme === 'light' ? 'tw-bg-white' : 'tw-bg-gray-700');

const themeBackgroundMessage = (theme: string) => (theme === 'light' ? 'white' : 'rgb(229 231 235 / var(--tw-bg-opacity))');

const calculateIframeDimensions = (screenWidth = 1080, screenHeight = 1920, baseWidth = 360, baseHeight = 640) => {
  const aspectRatio = 9 / 16;

  const maxWidth = Math.min(screenWidth, baseWidth);
  const maxHeight = Math.min(screenHeight, baseHeight);

  let newWidth, newHeight;

  if (maxHeight * aspectRatio <= maxWidth) {
    newHeight = maxHeight;
    newWidth = Math.floor(maxHeight * aspectRatio);
  } else {
    newWidth = maxWidth;
    newHeight = Math.floor(maxWidth / aspectRatio);
  }

  return { width: newWidth, height: newHeight };
};

export const widgetUtils = {
  bgColorMapper,
  bubbleBorderRadius,
  textColor,
  themeBorderColor,
  themeDisabledButtons,
  calculateIframeDimensions,
  themeBackground,
  themeBackgroundMessage,
};
